import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Crown, Check } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useState } from "react";

export default function Premium() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const upgrade = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        lookup_key: "premium_monthly",
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto anim-fade-up">
      <div className="cw-card p-8 sm:p-10 bg-gradient-to-br from-zinc-900 via-red-950/40 to-amber-950/30">
        <Crown className="w-12 h-12 text-amber-400 mb-4" />
        <h1 className="text-3xl sm:text-4xl font-display font-extrabold mb-2">CarnesWork Premium</h1>
        <p className="text-zinc-300 mb-6">
          Acesso ilimitado a profissionais qualificados. Prioridade no feed. Sem taxa por diária.
        </p>

        <div className="space-y-3 mb-8">
          {[
            "14 dias grátis — cancele quando quiser",
            "Publicações ilimitadas de diárias",
            "Prioridade no feed dos açougueiros Ouro/Master",
            "Painel de analytics de pagamentos",
            "Suporte prioritário para redes de supermercados",
            "Programa de parcerias corporativas",
          ].map(f => (
            <div key={f} className="flex gap-2 text-zinc-200 text-sm">
              <Check className="w-5 h-5 text-emerald-400 flex-shrink-0" /> {f}
            </div>
          ))}
        </div>

        <div className="flex items-baseline gap-2 mb-1">
          <span className="text-4xl font-display font-extrabold text-white">R$ 29,90</span>
          <span className="text-zinc-400">/mês</span>
        </div>
        <div className="text-xs text-emerald-400 font-semibold mb-6 uppercase tracking-wider">
          ✨ 14 dias grátis · só cobramos depois
        </div>

        {user?.is_premium ? (
          <div className="badge-pill status-completed">✓ Você já é Premium</div>
        ) : (
          <button onClick={upgrade} disabled={loading} className="cw-btn-primary w-full" data-testid="btn-upgrade-premium">
            {loading ? "Redirecionando…" : "Começar 14 dias grátis →"}
          </button>
        )}
      </div>
    </div>
  );
}
